/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AiModelPricingListModel } from '../../models/ai-model-pricing-list-model';

export interface SaveModelPricing$Params {
      body?: AiModelPricingListModel
}

export function SaveModelPricing(http: HttpClient, rootUrl: string, params?: SaveModelPricing$Params, context?: HttpContext): Observable<StrictHttpResponse<AiModelPricingListModel>> {
  const rb = new RequestBuilder(rootUrl, SaveModelPricing.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AiModelPricingListModel>;
    })
  );
}

SaveModelPricing.PATH = '/api/AIUsage/SaveModelPricing';
